// AvailabilityCards.jsx - Component for card view
import React from "react";
import {
  Box,
  Card as MuiCard,
  CardContent,
  Typography,
  Checkbox,
  styled,
} from "@mui/material";

const Card = styled(MuiCard)(({ theme }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: theme.shadows[4],
  },
}));

// Availability Card Component for ReusableTable
const AvailabilityCard = ({
  data: availability,
  selected: isSelected,
  onSelect,
  index,
}) => {
  const serialNumber = index + 1;

  return (
    <Card>
      <div style={{ position: "relative" }}>
        <div
          style={{
            backgroundColor: "#f0f0f0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "140px",
          }}
        >
          <Typography variant="h2" color="textSecondary">
            {availability.name.charAt(0).toUpperCase()}
          </Typography>
        </div>
        <Checkbox
          checked={isSelected}
          onChange={(e) => onSelect(e, availability.id)}
          style={{ position: "absolute", top: "8px", left: "8px" }}
        />
      </div>
      <CardContent sx={{ flexGrow: 1 }}>
        <Box>
          <Typography variant="h5" gutterBottom>
            {availability.name}
          </Typography>
        </Box>
        <Typography mb={2} color="textSecondary" component="p">
          S.No: {serialNumber}
          <br />
          Timezone: {availability.timezone}
          <br />
          Days: {availability.daysText || availability.days?.join(", ")}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Time Slots:{" "}
          {availability.timeSlotsCount || availability.timeSlots?.length || 0}{" "}
          configured
          <br />
          Overrides:{" "}
          {availability.overridesCount ||
            availability.overrides?.length ||
            0}{" "}
          scheduled
        </Typography>
      </CardContent>
    </Card>
  );
};

export default AvailabilityCard;
